import {BaseApiResponseModel} from "../../../infrastructure/models/base-api-response-model";

export class EntitiesRecognizerResponseApiModel extends BaseApiResponseModel {
  Athletes: Array<Number>;
  Competitions: Array<Number>;
  Competitors: Array<Number>;
  Games: Array<Number>;

  constructor(model: EntitiesRecognizerResponseApiModel) {
    super(model);

    this.Athletes = model?.Athletes;
    this.Competitions = model?.Competitions;
    this.Competitors = model?.Competitors;
    this.Games = model?.Games;
  }
}
